import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { PromoBanner } from "@/components/PromoBanner";
import { FloatingContact } from "@/components/FloatingContact";
import { Hero } from "@/components/Hero";
import { TrustSection } from "@/components/TrustSection";
import { Products } from "@/components/Products";
import { LifestyleGallery } from "@/components/LifestyleGallery";
import { ProductMenu } from "@/components/ProductMenu";
import { ScienceBenefits } from "@/components/ScienceBenefits";
import { BusinessOpportunity } from "@/components/BusinessOpportunity";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";
import { fetchContent, mergeContent } from "@/lib/api";
import { FALLBACK_CONTENT } from "@/data/site";

const promoKey = (text) => `ecentra_promo_dismissed_${(text || "").slice(0, 40)}`;

export default function Landing() {
  const [content, setContent] = useState(FALLBACK_CONTENT);
  const [bannerOpen, setBannerOpen] = useState(false);

  useEffect(() => {
    fetchContent()
      .then((c) => {
        const merged = mergeContent(FALLBACK_CONTENT, c);
        setContent(merged);
        const promo = merged.promo || {};
        const dismissed = localStorage.getItem(promoKey(promo.text));
        if (promo.enabled && promo.text && !dismissed) setBannerOpen(true);
      })
      .catch((err) => {
        console.error("Failed to load site content; using fallback:", err);
        setContent(FALLBACK_CONTENT);
      });
  }, []);

  const config = content.brand || FALLBACK_CONTENT.brand;
  const promo = content.promo || {};

  const closeBanner = () => {
    setBannerOpen(false);
    try {
      localStorage.setItem(promoKey(promo.text), "1");
    } catch (err) {
      console.error("Failed to persist promo dismissal:", err);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {bannerOpen ? <PromoBanner promo={promo} onClose={closeBanner} /> : null}
      <Navbar config={config} bannerOffset={bannerOpen} />
      <main>
        <Hero hero={content.hero} config={config} />
        <TrustSection about={content.about} />
        <Products content={content.products} payment={content.payment} />
        <LifestyleGallery />
        <ProductMenu content={content.productMenu} payment={content.payment} disclaimer={content.products?.disclaimer} />
        <ScienceBenefits />
        <BusinessOpportunity opportunity={content.opportunity} aboutMe={content.aboutMe} config={config} />
        <Testimonials testimonials={content.testimonials} />
        <FAQ faq={content.faq} />
        <Contact contact={content.contact} config={config} />
      </main>
      <Footer footer={content.footer} config={config} />
      <FloatingContact config={config} />
      <MobileCTA />
      <div className="h-14 lg:hidden" />
    </div>
  );
}
